import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const superAdminCredit = createAsyncThunk(
  "superAdminCredit/fetch",
  async (data, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/getAllCredits`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const superAdminCreditSlice = createSlice({
  name: "superAdminCredit",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {
    clearCreditData: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminCredit.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(superAdminCredit.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(superAdminCredit.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});
export const { clearCreditData } = superAdminCreditSlice.actions;
export default superAdminCreditSlice.reducer;
